import SupervisionModal from './SupervisionModal'
import QuoteModal from './QuoteModal'
import PaymentModal from './PaymentModal'
import VideoModal from './VideoModal'
import ShareModal from './ShareModal'

const contentOuterStyles = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: 'linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.95))',
  zIndex: 100,
  borderRadius: 0,
}

const closeButtonStyles = {
  width: '13px',
  height: '13px',
  border: 0,
  outline: 0,
  background: 'none',
  padding: 0,
  color: 'currentColor',
  cursor: 'pointer',
  position: 'absolute',
  top: 46,
  right: 60,
  transition: 'color 0.3s',
  zIndex: 10,
  '&:hover': {
    color: 'var(--c-red)',
  },
}

export const globalStyles = {
  contentOuter: () => ({
    ...contentOuterStyles,
  }),
  closeButton: () => ({
    ...closeButtonStyles,
  }),
  contentInner: () => ({
    overflow: 'auto',
    maxHeight: '100vh',
  }),
}

export const modals = {
  supervision: SupervisionModal,
  quote: QuoteModal,
  payment: PaymentModal,
  video: VideoModal,
  share: ShareModal,
}
